import {environment} from '../../environments/environment';
import {IconSizeModel} from './model/icon-size.model';

export const API_URL = `${environment.url}api`;
export const FILE_HOSTING_URL = `${environment.fileHostingApiUrl}`;
export const URL_REDIRECTION_URL = `${environment.urlRedirectionApiUrl}`;
export const FILE_HOSTING_API_URL = `${environment.fileHostingApiUrl}/api`;
export const URL_REDIRECTION_API_URL = `${environment.urlRedirectionApiUrl}api`;
export const URL_SHORTENER_API_URL = `${environment.urlShortenerUrl}api`;
export const URL_SHORTENER_URL = `${environment.urlShortenerUrl}`;
export const WS_URL = API_URL.replace('https', 'wss');
export const LOCAL_STORAGE_AUTH_TOKEN = 'auth-token';
export const LOCAL_STORAGE_ACCESS_TOKEN = 'access-token';
export const LOCAL_STORAGE_REFRESH_TOKEN = 'refresh-token';
export const LOCAL_STORAGE_ACCESS_TOKEN_EXPIRES = 'access-token-expires';
export const LOCAL_STORAGE_REFRESH_TOKEN_EXPIRES = 'refresh-token-expires';
export const LOCAL_STORAGE_LEFT_BAR_PINNED = 'left-bar-pinned';
export const LOCAL_STORAGE_ONLY_ICONS = 'only-icons';
export const LOCAL_STORAGE_MACHINES_AUTO_UPDATE = 'machines-auto-update';
export const LOCAL_STORAGE_MACHINES_UPDATE_INTERVAL_MS = 'machines-auto-update-interval-ms';
export const LOCAL_STORAGE_TRANSFER_UPDATE_INTERVAL_MS = 'transfer-auto-update-interval-ms';
export const LOCAL_STORAGE_ACCOUNT_DETAILS = 'account-details';
export const LOCAL_STORAGE_ACCOUNT_PERMISSIONS = 'account-claims';

export const RIGHT_BAR_PROFILE = 'profile';
export const RIGHT_BAR_MAILBOX = 'mailbox';
export const RIGHT_BAR_SYNC_CONFIGURATIONS = 'sync-configurations';
export const RIGHT_BAR_SYNC_STATUS = 'sync-status';
export const RIGHT_BAR_ACCESS_PERMISSIONS = 'access-permissions';
export const RIGHT_BAR_MACHINES_PERMISSIONS = 'machines-permissions';
export const RIGHT_BAR_ORG_PERSONAL_DATA_PERMISSIONS = 'org-personal-data-permissions';
export const RIGHT_BAR_FILE_SERVICES = 'file-services';
export const RIGHT_BAR_USER_PROFILE = 'user-profile';
export const RIGHT_BAR_USER_SESSIONS = 'user-sessions';
export const RIGHT_BAR_REMOTE_DESKTOP = 'remote-desktop';
export const RIGHT_BAR_URL_ADMIN_RULES = 'url-admin-rules';
export const RIGHT_BAR_CLONE_URL_ADMIN_EMPLOYEE = 'clone-url-admin-employee';
export const RIGHT_BAR_CLONE_URL_ADMIN = 'clone-url-admin';
export const RIGHT_BAR_EMPLOYEES = 'employees';
export const RIGHT_BAR_EMPLOYEE = 'employee';
export const RIGHT_BAR_RELATED_EMPLOYEE = 'related-employee';
export const RIGHT_BAR_ADD_PERSONAL_DATA_RELATIONS = 'add-personal-data-relations';
export const RIGHT_BAR_LOGS = 'logs';

export const RIGHT_BAR_EMPLOYEE_REPORT = 'personal-data-report';
export const RIGHT_BAR_EMPLOYEE_PERSONAL_INFORMATION = 'personal-information';
export const RIGHT_BAR_EMPLOYEE_ADDRESSES = 'addresses';
export const RIGHT_BAR_EMPLOYEE_EDUCATION = 'education';
export const RIGHT_BAR_EMPLOYEE_WORK_EXPERIENCE = 'work-experience';
export const RIGHT_BAR_EMPLOYEE_URL_ADMIN = 'url-administration';
export const RIGHT_BAR_EMPLOYEE_REGISTERED_COMPANIES = 'registered-companies';
export const RIGHT_BAR_EMPLOYEE_COMMUNICATION = 'communication';
export const RIGHT_BAR_EMPLOYEE_NOTES = 'notes';
export const RIGHT_BAR_EMPLOYEE_PSYCHOLOGICAL_PORTRAITS = 'psychological-portraits';
export const RIGHT_BAR_EMPLOYEE_RELATIONS = 'relations';
export const RIGHT_BAR_EMPLOYEE_PHOTOS = 'photos';
export const RIGHT_BAR_EMPLOYEE_ASSIGNED_MACHINES = 'assigned-machines';
export const RIGHT_BAR_EMPLOYEE_PHONE = 'phone';
export const RIGHT_BAR_EMPLOYEE_SOCIAL_MEDIA = 'social-media';
export const RIGHT_BAR_EMPLOYEE_EMAILS = 'emails';
export const RIGHT_BAR_EMPLOYEE_SALARY = 'salary';
export const RIGHT_BAR_EMPLOYEE_DEPOSITS = 'deposits';
export const RIGHT_BAR_EMPLOYEE_LOANS = 'loans';
export const RIGHT_BAR_RELATED_EMPLOYEE_REPORT = 'related-personal-data-report';
export const RIGHT_BAR_RELATED_EMPLOYEE_PERSONAL_INFORMATION = 'related-personal-information';
export const RIGHT_BAR_RELATED_EMPLOYEE_ADDRESSES = 'related-addresses';
export const RIGHT_BAR_RELATED_EMPLOYEE_EDUCATION = 'related-education';
export const RIGHT_BAR_RELATED_EMPLOYEE_WORK_EXPERIENCE = 'related-work-experience';
export const RIGHT_BAR_RELATED_EMPLOYEE_URL_ADMIN = 'related-url-administration';
export const RIGHT_BAR_RELATED_EMPLOYEE_REGISTERED_COMPANIES = 'related-registered-companies';
export const RIGHT_BAR_RELATED_EMPLOYEE_NOTES = 'related-notes';
export const RIGHT_BAR_RELATED_EMPLOYEE_PSYCHOLOGICAL_PORTRAITS = 'related-psychological-portraits';
export const RIGHT_BAR_RELATED_EMPLOYEE_RELATIONS = 'related-relations';
export const RIGHT_BAR_RELATED_EMPLOYEE_PHOTOS = 'related-photos';
export const RIGHT_BAR_RELATED_EMPLOYEE_ASSIGNED_MACHINES = 'related-assigned-machines';
export const RIGHT_BAR_RELATED_EMPLOYEE_PHONE = 'related-phone';
export const RIGHT_BAR_RELATED_EMPLOYEE_SOCIAL_MEDIA = 'related-social-media';
export const RIGHT_BAR_RELATED_EMPLOYEE_EMAILS = 'related-emails';
export const RIGHT_BAR_RELATED_EMPLOYEE_SALARY = 'related-salary';
export const RIGHT_BAR_RELATED_EMPLOYEE_DEPOSITS = 'related-deposits';
export const RIGHT_BAR_RELATED_EMPLOYEE_LOANS = 'related-loans';

export const LEFT_BAR_WIDTH = '250px';

export const LEFT_BAR_WIDTH_MOBILE = '140px';

export const LEFT_BAR_WIDTH_ICONS_ONLY = '80px';

export const LEFT_BAR_WIDTH_ICONS_ONLY_MOBILE = '50px';

export const DEFAULT_LOCALE = 'en';

export const SKIP_LOADING = 'skipLoading';

export const DEFAULT_TABLE_ROWS_OPTIONS = [50, 100, 200];
export const MACHINE_ACTIVITY_LOGS_LIMIT = 200;
export const MACHINE_FILE_SERVICES_LIMIT = 200;
export const USERS_LIMIT = 200;
export const USER_SESSIONS_LIMIT = 200;
export const HOSTED_SERVICES_LIMIT = 200;
export const HOSTED_SERVICES_JOBS_LIMIT = 200;
export const EMPLOYEES_LIMIT = 200;
export const HOSTING_FILES_LIMIT = 200;
export const URL_ADMIN_LIMIT = 200;
export const URL_SHORTENER_LIMIT = 200;
export const URL_REDIRECTION_LIMIT = 200;
export const URL_ADMIN_LOGS_LIMIT = 200;
export const FILE_HOSTING_LOGS_LIMIT = 200;
export const URL_SHORTENER_LOGS_LIMIT = 200;
export const URL_ADMIN_RULES_LIMIT = 200;
export const URL_STATISTICS_LIMIT = 200;
export const ROLES_LIMIT = 200;
export const ADDRESSES_LIMIT = 200;
export const EDUCATION_LIMIT = 200;
export const WORKS_LIMIT = 200;
export const REGISTERED_COMPANIES_LIMIT = 200;
export const PHONE_NUMBERS_LIMIT = 200;
export const SOCIAL_MEDIA_LIMIT = 200;
export const EMAILS_LIMIT = 200;
export const MAX_PAGING_LIMIT = 999999; // todo
export const MACHINES_LIMIT = 200;
export const FILE_CATEGORIES_LIMIT = 200;
export const FILE_EXTENSIONS_LIMIT = 200;
export const DEFAULT_TABLE_LIMIT = 200;
export const DEPOSITS_LIMIT = 200;
export const SALARIES_LIMIT = 200;
export const LOANS_LIMIT = 200;
export const NOTES_LIMIT = 200;
export const ASSIGNED_MACHINES_LIMIT = 200;
export const PSYCHOLOGICAL_PORTRAITS_LIMIT = 200;
export const RELATIONS_LIMIT = 200;
export const LOCAL_STORAGE_MACHINES_LIMIT = 'machines-limit';
export const LOCAL_STORAGE_FILE_CATEGORIES_LIMIT = 'file-categories-limit';
export const LOCAL_STORAGE_FILE_EXTENSIONS_LIMIT = 'file-extensions-limit';
export const LOCAL_STORAGE_MACHINE_ACTIVITY_LOGS_LIMIT = 'machine-activity-logs-limit';
export const LOCAL_STORAGE_MACHINE_FILE_SERVICES_LIMIT = 'machine-file-services-limit';
export const LOCAL_STORAGE_USERS_LIMIT = 'users-limit';
export const LOCAL_STORAGE_USER_SESSIONS_LIMIT = 'user-sessions-limit';
export const LOCAL_STORAGE_HOSTED_SERVICES_LIMIT = 'hosted-services-limit';
export const LOCAL_STORAGE_HOSTED_SERVICES_JOBS_LIMIT = 'hosted-services-jobs-limit';
export const LOCAL_STORAGE_EMPLOYEES_LIMIT = 'employees-limit';
export const LOCAL_STORAGE_URL_ADMIN_LIMIT = 'url-admin-limit';
export const LOCAL_STORAGE_URL_SHORTENER_LIMIT = 'url-shortener-limit';
export const LOCAL_STORAGE_URL_REDIRECTION_LIMIT = 'url-redirection-limit';
export const LOCAL_STORAGE_URL_ADMIN_LOGS_LIMIT = 'url-admin-logs-limit';
export const LOCAL_STORAGE_URL_SHORTENER_LOGS_LIMIT = 'url-shortener-logs-limit';
export const LOCAL_STORAGE_FILE_HOSTING_LOGS_LIMIT = 'file-hosting-logs-limit';
export const LOCAL_STORAGE_URL_ADMIN_RULES_LIMIT = 'url-admin-rules-limit';
export const LOCAL_STORAGE_URL_STATISTICS_LIMIT = 'url-admin-statistics-limit';
export const LOCAL_STORAGE_ROLES_LIMIT = 'roles-limit';
export const LOCAL_STORAGE_ADDRESSES_LIMIT = 'addresses-limit';
export const LOCAL_STORAGE_EDUCATION_LIMIT = 'education-limit';
export const LOCAL_STORAGE_WORKS_LIMIT = 'works-limit';
export const LOCAL_STORAGE_REGISTERED_COMPANIES_LIMIT = 'registered-companies-limit';
export const LOCAL_STORAGE_PHONE_NUMBERS_LIMIT = 'phone-numbers-limit';
export const LOCAL_STORAGE_SOCIAL_MEDIA_LIMIT = 'social-media-limit';
export const LOCAL_STORAGE_EMAILS_LIMIT = 'emails-limit';
export const LOCAL_STORAGE_DEPOSITS_LIMIT = 'deposits-limit';
export const LOCAL_STORAGE_SALARIES_LIMIT = 'salaries-limit';
export const LOCAL_STORAGE_LOANS_LIMIT = 'loans-limit';
export const LOCAL_STORAGE_NOTES_LIMIT = 'notes-limit';
export const LOCAL_STORAGE_ASSIGNED_MACHINES_LIMIT = 'assigned-machines-limit';
export const LOCAL_STORAGE_PSYCHOLOGICAL_PORTRAITS_LIMIT = 'psychological-portraits-limit';
export const LOCAL_STORAGE_RELATIONS_LIMIT = 'relations-limit';
export const LOCAL_STORAGE_THEME = 'theme';
export const LOCAL_STORAGE_LANGUAGE = 'language';

export const SOCIAL_MEDIA_NAMES = [
  'Facebook',
  'Instagram',
  'Twitter',
  'LinkedIn',
  'Pinterest',
  'Snapchat',
  'YouTube',
  'Reddit',
  'Tumblr',
  'WhatsApp',
  'Telegram',
  'WeChat',
  'Viber',
  'Skype',
  'Pinterest',
  'Flickr',
  'Medium',
  'Quora',
  'Vimeo',
  'Periscope',
  'TikTok',
  'Snapchat',
  'SoundCloud',
  'Foursquare',
  'Meetup',
  'Yelp',
  'Digg',
  'Mix',
  'DeviantArt',
  'Google+',
  'Behance',
  'Dribbble',
  '500px',
  'SlideShare',
  'StumbleUpon',
  'VKontakte',
  'Odnoklassniki',
  'LiveJournal',
  'Xing',
  'Renren',
  'Sina Weibo',
  'We Heart It',
  'Twitch',
  'Myspace',
  'Tagged',
  'Hi5',
  'Orkut',
  'Renren',
  'Meowchat',
  'Path',
  'Periscope',
  'Yo',
  'Plurk',
  'MeetMe',
  'Amino Apps',
  'Nextdoor',
  'Crunchyroll',
  'Taringa!',
  'Badoo',
  'Twoo',
  'Qzone',
  'Renren',
  'Weibo',
  'Douban',
  'Mastodon',
  'Ello',
  'Gab',
  'MeWe',
  'Parler',
  'Rumble',
  'Voat',
  'Snapzu',
  'Minds',
  'Flote',
  'Diaspora',
  'Friendica',
  'Gettr',
  'Triller',
  'Trovo',
  'Clubhouse',
  'Anchor',
  'Rumble',
  'Kuaishou',
  'Triller',
  'Zhihu',
  'Meipai',
  'Rediff',
  'Plaxo',
  'Zorpia',
  'Ning',
  'Xanga',
  'TagWorld',
  'Shutterfly',
  'Webshots',
  'Flixster',
  'Hyves',
  'Netlog',
  'Renren',
  'Hi5',
  'Mixi',
  'Cyworld',
  'Orkut',
  'Friendster',
  'Jaiku',
  'Plazes',
  'Dopplr',
  'Last.fm',
  'LiveJournal',
  'Xanga',
  'TypePad',
  'Blogger',
  'WordPress',
  'Medium',
  'Ghost',
  'Squarespace',
  'Wix',
  'Weebly',
  'Jimdo',
  'Strikingly',
  'Zoho Sites',
  'Google Sites',
  'Homestead',
  'Tripod',
  'Bravenet',
  'Angelfire',
  'Freewebs',
  'Webs',
  'Geocities',
  'Neocities',
  'Carrd',
  'About.me',
  'Flavors.me',
  'Cargo',
  'Carbonmade',
  'Behance',
  'Dribbble',
  'Coroflot',
  'Cargo',
  'Portfoliobox',
  'ArtStation',
  'Designspiration',
  'Dunked',
  'Krop',
  'Carbonmade',
  'Semplice',
  'Adobe Portfolio',
  'Journo Portfolio',
  'Flickr',
  '500px',
  'Behance',
  'Dribbble',
  'DeviantArt',
  'ArtStation',
  'Pixiv',
  'Designspiration',
  'Ello',
  'EyeEm',
  'Adobe Stock',
  'Getty Images',
  'Shutterstock',
  'Unsplash',
  'Pexels',
  'Pixabay',
  'Flickr',
  '500px',
  'Photobucket',
  'SmugMug',
  'Snapfish',
  'Shutterfly',
  'Zenfolio',
  'Mix',
  'StumbleUpon',
  'Diigo',
  'Pocket',
  'Instapaper',
  'Flipboard',
  'Scoop.it',
  'Delicious',
  'Digg',
  'Slashdot',
  'Fark',
  'Newsvine',
  'MetaFilter',
  'Y Combinator',
  'Product Hunt',
  'Hacker News',
  'Designer News',
  'Reddit',
  'Voat',
  'Snapzu',
  'Minds',
  'Flote',
  'Gab',
  'Parler',
  'Gettr',
  'Triller',
  'Clash',
  'DLive',
  'LiveLeak',
  'Rumble',
  'Bitchute',
  'BitTube',
  'Brighteon',
  'BrandNewTube',
  'Odysee',
  'PeerTube',
  'VidLii',
  'LBRY',
  'D.Tube',
  'BitChute',
  'Rokfin',
  'Xfinite',
  'Stitcher',
  'Spreaker',
  'BlogTalkRadio',
  'Anchor',
  'Podbean',
  'Buzzsprout',
  'Libsyn',
  'SoundCloud',
  'Mixlr',
  'Acast',
  'Blubrry',
  'Transistor',
  'Simplecast',
  'Zencast',
  'RedCircle',
  'Castos',
  'Pippa',
  'Podomatic',
  'Megaphone',
  'Whooshkaa',
  'Audioboom',
  'Chartable',
  'Podchaser',
  'Listen Notes',
  'Podknife',
  'Vurbl',
  'Podtail',
  'RadioPublic',
  'Player FM',
  'iHeartRadio',
  'TuneIn',
  'Pandora',
  'Spotify',
  'Apple Podcasts',
  'Google Podcasts',
  'Stitcher',
  'Deezer',
  'Podbean',
  'Overcast',
  'Castbox',
  'Pocket Casts',
  'RSS',
  'Castro',
  'Breaker',
  'Podchaser',
  'Listen Notes',
  'Podknife',
  'Vurbl',
  'Podtail',
  'RadioPublic',
  'Player FM',
  'iHeartRadio',
  'TuneIn',
  'Pandora',
  'Spotify',
  'Apple Music',
  'Google Play Music',
  'Amazon Music',
  'Tidal',
  'Deezer',
  'SoundCloud',
  'Mixcloud',
  'Bandcamp',
  'ReverbNation',
  'SoundClick',
  'DatPiff',
  'BeatStars',
  'Clyp',
  'HearThisAt',
  'Audiomack',
  'Soundation',
];

export const ICON_SIZES: IconSizeModel[] = [
  {name: 'Details', icon: 'pi pi-list', code: 'details', class: 'iconsDetails',},
  {name: 'Extra Large Icons', icon: 'pi pi-desktop', code: 'extraLarge', class: 'extraLargeIcons', iconSize: '1.2rem'},
  {name: 'Large Icons', icon: 'pi pi-desktop', code: 'large', class: 'largeIcons', iconSize: '1rem'},
  {name: 'Medium Icons', icon: 'pi pi-desktop', code: 'medium', class: 'mediumIcons', iconSize: '0.8rem'},
  {name: 'Small Icons', icon: 'pi pi-desktop', code: 'small', class: 'smallIcons', iconSize: '0.6rem'},
];

export const IMAGE_EXTENSIONS = ['JPEG', 'JPG', 'PNG ', 'WEBP', 'ICO', 'SVG', 'RAW', 'HEIC', 'HEIF', 'GIF', 'BMP'];
export const TEXT_EXTENSIONS = ['ASC', 'DOC', 'DOCX ', 'RTF', 'MSG', 'PDF', 'TXT', 'WPD', 'WPS'];

export const FILE_VALIDATION_MESSAGE =
  `Only files with the following extensions: ${IMAGE_EXTENSIONS},
  ${TEXT_EXTENSIONS}
  and under 2MB can be previewed.
  Please ensure your file meets these requirements.`

export const MAX_FILE_SIZE_FOR_PREVIEW = 2097152;
